export const emojiCategories = {
    "😀": [
        '😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊', '😋', '😎', '😍', '😘', '😗', '😙', '😚',
        '🙂', '🤗', '🤔', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮', '🤐', '😯', '😪', '😫', '😴', '😌',
        '😭', '😢', '😤', '😠', '😡', '🤬', '😳', '🥺', '😞', '😔', '😟', '😕', '🙃', '😇', '🤠', '🤡', '🥰', '🤩', '😱', '😰', '😓'
    ],
    "👋": [
        '👋', '🤚', '🖐', '✋', '🖖', '👌', '🤏', '✌', '🤞', '🤟', '🤘', '🤙',
        '👈', '👉', '👆', '👇', '👍', '👎', '👏', '🙌', '👐', '🙏', '💪', '🤝', '🤲',
        '🙅', '🙆', '🙇', '🤦', '🤷', '💁', '🙋', '🧏', '🤵', '👰', '👸', '🤴', '🧑', '👨', '👩', '👧', '👦', '🧒', '👶'
    ],
    "🐶": [
        '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵',
        '🐔', '🐧', '🐦', '🐤', '🐣', '🦆', '🦅', '🦉', '🐺', '🐗', '🐴', '🦄', '🐝', '🦋', '🐞',
        '🐛', '🐜', '🕷', '🐢', '🐍', '🦎', '🦖', '🐙', '🦑', '🐠', '🐟', '🐬', '🐳', '🐋',
        '🌸', '🌹', '🌻', '🌼', '🌷', '🌺', '🌾', '🌵', '🌲', '🌳', '🍀', '🍁', '🍂', '🍃'
    ],
    "🍔": [
        '🍏', '🍎', '🍊', '🍋', '🍉', '🍇', '🍓', '🍒', '🍑', '🍍',
        '🥭', '🥝', '🍅', '🥥', '🥑', '🍆', '🥦', '🥕', '🌽', '🍄',
        '🥔', '🍔', '🍟', '🍕', '🌭', '🌮', '🌯', '🥗', '🍣', '🍤',
        '🍙', '🍚', '🍛', '🍜', '🍝', '🥮', '🍰', '🎂', '🍩', '🍪', '🍫', '🍿',
        '🍺', '🍻', '🍷', '🥂', '🍸', '🍹', '🍾', '🥤', '☕', '🍵'
    ],
    "⚽": [
        '⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🏉', '🎱', '🏓', '🏸', '🥅', '🏒', '🏑', '🏏', '🏹',
        '🥊', '🥋', '🎽', '⛳', '🎯', '🎳', '🥌', '🎮', '🎲', '🧩', '🎭', '🎨', '🎤', '🎧', '🎹', '🥁', '🎬', '🎥'
    ],
    "✈️": [
        '🚗', '🚕', '🚙', '🚌', '🚎', '🏎', '🚓', '🚑', '🚒', '🚚', '🚜', '🏍', '🚲', '🚃', '🚆',
        '🚄', '🚅', '🚇', '🚊', '🚉', '✈️', '🚀', '🛸', '🚢', '⛵', '🚤', '🛶', '🚁', '🏠', '🏡', '🏢', '🏬', '🏰', '🗻', '🌋', '🏝'
    ],
    "💡": [
        '💡', '🔦', '🕯', '💻', '🖥', '📱', '📷', '📹', '📺', '📻',
        '🎥', '💿', '📀', '💾', '📸', '⌚', '⌨', '🖱', '🖨', '🔋', '🔌', '💰', '💳', '💎', '🧭', '🧱', '🔧', '🔨', '🔩'
    ],
    "❤️": [
        '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎',
        '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝',
        '💟', '💬', '💭', '💤', '💢', '💥', '💦', '💨', '✨', '🔥', '🌟', '⭐', '🎉', '🎊', '⚡'
    ],
    "🏳️": [
        '🏳️', '🏴', '🏁', '🚩'
    ]
};

export const allowedReactions = ["👍", "❤️", "😂", "😮", "😢", "👎"];

export const defaultReaction = "👍"


// WEBPACK FOOTER //
// ./src/utils/Emojis.js